export default __webpack_public_path__ + "static/media/favicon.2392ebd5.ico";